import TenantService from 'App/services/tenant';
import React from 'react';
import filterXss from 'xss';

import LogService from '../../utils/log';

const CallMeForm = ({ id = 'call-me', title, text }) => <section className="cta-call-me" id={id}>
  <div className="cta-section__content">
    <h2 className="fr-title">{title}</h2>
    <h5 className="fr-subtitle">{text}</h5>
    <form action="/for-restaurants" method="POST" onSubmit={callMeFormSubmit}>
      <div className="fr-inputs-wrapper">
        <input type="text" name="name" className="fr-input" placeholder="np. Jan Kowalski" required />
        <input type="tel" name="phone" className="fr-input" placeholder="Twój numer telefonu" required />
        <input type="text" name="restaurant" className="fr-input" placeholder="Nazwa restauracji" required />
        <input type="submit" name="fr-submit" className="for-restaurants-cta-btn" value="Proszę o kontakt" id="fr-submit" />
      </div>
      <div className="fr-checkbox-wrapper">
        <input type="checkbox" name={`rodo-agree-${id}`} id={`rodo-agree-${id}`} required />
        <label htmlFor={`rodo-agree-${id}`}>
          Wyrażam zgodę na przetwarzanie moich danych osobowych w celu marketingowym oraz do kontaktu telefonicznego w celu przedstawienia oferty handlowej.
        <a href={TenantService.getForRestaurateursPagePrivacyPolicyLink()} className="ml-1">Polityka prywatności</a>
        </label>
      </div>
    </form>
  </div>
</section>;

export function callMeFormSubmit(event) {
  event.preventDefault();
  event.stopPropagation();
  
  const formElements = event.target.elements || document.forms[0].elements;
  
  const name = formElements[0].value;
  const phone = formElements[1].value;
  const restaurant = formElements[2].value;
  
  const message = `Nowa prośba kontaktu ze strony!
    Adres: ${filterXss(window.location.href)}
    Osoba kontaktowa: ${name}
    Telefon kontaktowy: ${phone}
    Restauracja: ${restaurant}`
  LogService.salesActivity(message);
  showThankYouModal();
  return false;
}

function showThankYouModal() {
  $('#thankYouModal').modal('show');
}

export default React.memo(CallMeForm);
